import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./Authentication/Login";
import Unauthorized from "./Common/Unauthorized";
import Flights from "./Components/Flight/Flights";
import SearchFlight from "./Components/Flight/SearchFlight";
import CompanyProfile from "./Components/Master/CompanyProfile";
import Branch from "./Components/Master/Branch";
import Supplier from "./Components/Master/Supplier";
import LeadStatus from "./Components/Marketing/LeadStatus";
import Users from "./Components/Master/Users";

import FlightDetails from "./Components/Flight/FlightDetails";
import DestinationType from "./Components/Master/DestinationType";
import Destination from "./Components/Master/Destination";
import TravelType from "./Components/Master/TravelType";
import PackageComponent from "./Components/Package/CreatePackage";
import PackageList from "./Components/Package/PackageList";
import Marketing from "./Components/Marketing/Marketing";
import ReviewFlight from "./Components/Flight/ReviewFlight";
import PaymentGateway from "./Components/Master/PaymentGateway";
import Customer from "./Components/Master/Customer";
import Source from "./Components/Marketing/Source";
import Lead from "./Components/Marketing/Lead";
import LeadCalendar from "./Components/Marketing/LeadCalendar";
import Umrah from "./Components/Umrah/CreateUmrah";
import UmrahList from "./Components/Umrah/UmrahList";
import FlightBookingDetails from "./Components/Flight/FlightBookingDetails";
import FlightBookings from "./Components/Flight/FlightBookings";
import FlightVoucher from "./Components/Flight/FlightVoucher";
import SearchHotel from "./Components/Hotels/SearchHotels";
import HotelsList from "./Components/Hotels/HotelsList";
import Currency from "./Components/Master/Currency";
import FlightInvoice from "./Components/Flight/FlightInvoice";
import SightSeeingSearch from "./Components/SightSeeing/SightSeeingSearch";
import SightSeeingProducts from "./Components/SightSeeing/SightSeeingProducts";
import SightSeeingProduct from "./Components/SightSeeing/SightSeeingProduct";
import HotelDetails from "./Components/Hotels/HotelDetails";
import PackageDate from "./Components/Package/PackageDate";
import HotelGuests from "./Components/Hotels/HotelGuests";
import EnquiryList from "./Components/Package/EnquiryList";
import LandingPage from "./Components/Settings/LandingPage";
import HotelReview from "./Components/Hotels/HotelReview";
import HotelBookings from "./Components/Hotels/HotelBookings";
import HotelBookingDetails from "./Components/Hotels/HotelBookingDetails";
import HotelVoucher from "./Components/Hotels/HotelVoucher";
import HotelInvoice from "./Components/Hotels/HotelInvoice";
import FromOrigin from "./Components/Package/FromOrigin";
import GroupBookings from "./Components/Flight/GroupBookings";
import Dashboard from "./Components/Dashboard/Dashboard";
import Hajj from "./Components/Hajj/CreateHajj";
import HajjList from "./Components/Hajj/HajjList";
import HajjEnquiry from "./Components/Hajj/HajjEnquiry";
import UmrahEnquiryList from "./Components/Umrah/UmrahEnquiryList";
import FlightReport from "./Components/Report/FlightReport";
import HotelReport from "./Components/Report/HotelReport";
import GstReport from "./Components/Report/GstReport";
import AgentPayments from "./Components/Companies/AgentPayments";
import AgentCredits from "./Components/Companies/AgentCredits";
import AgentInvoice from "./Components/Companies/AgentInvoice";
import SightSeeingBooking from "./Components/SightSeeing/SightSeeingBooking";
import SightSeeingBookingDetails from "./Components/SightSeeing/SightSeeingBookingDetails";
import ChangePassword from "./Components/Master/ChangePassword";
import PackageTemplates from "./Components/Package/PackageTemplates";
import SearchVisas from "./Components/Visas/Visas";
import PendingPayments from "./Components/Visas/PendingPayments";
import VisaRequests from "./Components/Visas/VisaRequests";
import VisaInvoice from "./Components/Visas/VisaInvoice";
import VisaHistory from "./Components/Visas/VisaHistory.jsx";
import Promotions from "./Components/Marketing/Promotions.jsx";
import LeadManagementDashboard from "./Components/Marketing/LeadDashboard.jsx";
import WebsitePackageList from "./Components/Package/WebsitePackageList.jsx";
import LeadReports from "./Components/Marketing/LeadReports.jsx";
import CreditHistory from "./Components/Master/CreditHistory.jsx";
import VisaRequestDetail from "./Components/Visas/VisaRequestDetails.jsx";
import VisaRequestReports from "./Components/Visas/VisaRequestReport.jsx";
import VisaSupplierReports from "./Components/Visas/VisaSupplierReport.jsx";
import SaasRegister from "./Authentication/SaasRegistration.jsx";
import ForgotPassword from "./Authentication/ForgotPassword.jsx";
import { RESETPASSWORD } from "./Common/Configurations/APIConfig.jsx";
import WebsiteUmrahList from "./Components/Umrah/WebsiteUmrahList.jsx";
import WebsiteHajjList from "./Components/Hajj/WebsiteHajjList.jsx";
import Companies from "./Components/Admin/Companies.jsx";
import VisaPrice from "./Supplier/VisaPrices.jsx";
import Requests from "./Supplier/Requests.jsx";
import SightSeeingBookings from "./Components/SightSeeing/SightSeeingBookings.jsx";
import Suppliers from "./Components/Admin/Suppliers.jsx";
import Agents from "./Components/Companies/Agent.jsx";
import BusSearch from "./Components/Bus/SearchBus.jsx";
import BusResults from "./Components/Bus/BusResults.jsx";
import BookingDetails from "./Components/Bus/BookingDetails.jsx";
import BusPayment from "./Components/Bus/BusPayment.jsx";
import BusBookingConfirmation from "./Components/Bus/BusBookingConfirmation.jsx";
import BusBookingList from "./Components/Bus/BusBookingList.jsx";
import BusSeatSelection from "./Components/Bus/BusSeatSelection.jsx"; 
import CompanyBankAccounts from "./Components/Master/CompanyBankAccounts.jsx";
import CompanySuppliers from "./Components/Admin/CompanySuppliers.jsx";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/flight/search" element={<SearchFlight />} />
        <Route path="/hotel/search" element={<SearchHotel />} />
        <Route path="/sightseeing/search" element={<SightSeeingSearch />} />
        <Route path="/umrah" element={<Umrah />} />
        <Route path="/packageslist" element={<PackageList />} />
        <Route path="/hajjList" element={<HajjList />} />

        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<SaasRegister />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/resetpassword" element={<RESETPASSWORD />} />

        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/companyprofile" element={<CompanyProfile />} />
        <Route path="/companieslist" element={<Companies />} />
        <Route path="/supplierlist" element={<Suppliers />} />
        <Route path="/agentlist" element={<Agents />} />
        <Route path="/branchs" element={<Branch />} />
        <Route path="/users" element={<Users />} />
        <Route path="/leadstatus" element={<LeadStatus />} />
        <Route path="/source" element={<Source />} />
        <Route path="/leads" element={<Lead />} />
        <Route path="/leaddashboard" element={<LeadManagementDashboard />} />
        <Route path="/leadreports" element={<LeadReports />} />
        <Route path="/currency" element={<Currency />} />
        <Route path="/paymentgateways" element={<PaymentGateway />} />
        <Route path="/suppliers" element={<Supplier />} />
        <Route path="/changepassword" element={<ChangePassword />} />
        <Route path="/promotion" element={<Promotions />} />

        <Route
          path="/flights/:adults?/:kids?/:infants?/:isDomestic?"
          element={<Flights />}
        />
        <Route
          path="/flightdetails/:adults?/:kids?/:infants?/:isDomestic?"
          element={<FlightDetails />}
        />
        <Route
          path="/flight/review/:adults?/:kids?/:infants?/:isDomestic?"
          element={<ReviewFlight />}
        />
        <Route path="/flight/bookings" element={<FlightBookings />} />
        <Route
          path="/flight/booking/:flightBookingId"
          element={<FlightBookingDetails />}
        />
        <Route
          path="/flight/voucher/:flightBookingId"
          element={<FlightVoucher />}
        />
        <Route
          path="/flight/invoice/:flightBookingId"
          element={<FlightInvoice />}
        />

        <Route path="/hotels" element={<HotelsList />} />
        <Route path="/hotel/details" element={<HotelDetails />} />
        <Route path="/hotel/guests" element={<HotelGuests />} />
        <Route path="/hotel/review" element={<HotelReview />} />
        <Route path="/hotel/bookings" element={<HotelBookings />} />
        <Route
          path="/hotel/booking/:hotelBookingId"
          element={<HotelBookingDetails />}
        />
        <Route
          path="/hotel/voucher/:hotelBookingId"
          element={<HotelVoucher />}
        />
        <Route
          path="/hotel/invoice/:hotelBookingId"
          element={<HotelInvoice />}
        />

        <Route
          path="/sightseeing/products/:destinationCode/:destination/:adults?/:kids?/:travelDate"
          element={<SightSeeingProducts />}
        />
        <Route
          path="/sightseeing/product/:productId/:destinationCode/:destination/:adults?/:kids?/:travelDate"
          element={<SightSeeingProduct />}
        />
        <Route
          path="/sightseeing/booking/:productId/:destinationCode/:destination/:adults?/:kids?/:travelDate"
          element={<SightSeeingBooking />}
        />
        <Route
          path="/sightseeing/booking/:sightSeeingBookingId"
          element={<SightSeeingBookingDetails />}
        />
        <Route path="/sightseeing/bookings" element={<SightSeeingBookings />} />

        <Route path="/destinationtypes" element={<DestinationType />} />
        <Route path="/destinations" element={<Destination />} />
        <Route path="/traveltypes" element={<TravelType />} />
        <Route path="/package/:packageId?" element={<PackageComponent />} />
        <Route
          path="/packagedetails/:packageId"
          element={<PackageTemplates />}
        />
        <Route path="/websitepackages" element={<WebsitePackageList />} />
        <Route path="/websiteumrahpackages" element={<WebsiteUmrahList />} />
        <Route path="/websitehajjpackages" element={<WebsiteHajjList />} />

        <Route path="/marketing" element={<Marketing />} />
        <Route path="/customers" element={<Customer />} />
        <Route path="/leadcalendar" element={<LeadCalendar />} />

        <Route path="/packagedates" element={<PackageDate />} />
        <Route path="/orign" element={<FromOrigin />} />
        <Route path="/enquirylist" element={<EnquiryList />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/landingpage" element={<LandingPage />} />
        <Route path="/groupbookings" element={<GroupBookings />} />

        <Route path="/umrahList" element={<UmrahList />} />
        <Route path="/umrahpackage/:packageId?" element={<Umrah />} />
        <Route path="/umrahenquiry" element={<UmrahEnquiryList />} />

        <Route path="/hajjpackage/:packageId?" element={<Hajj />} />
        <Route path="/hajj" element={<Hajj />} />

        <Route path="/hajjenquiry" element={<HajjEnquiry />} />

        <Route path="/flightreport" element={<FlightReport />} />
        <Route path="/hotelreport" element={<HotelReport />} />
        <Route path="/gstreport" element={<GstReport />} />

        <Route path="/agents" element={<Agents />} />
        <Route path="/agent/payments" element={<AgentPayments />} />
        <Route path="/agent/credits" element={<AgentCredits />} />
        <Route path="/agent/invoices" element={<AgentInvoice />} />

        <Route path="/visa/search" element={<SearchVisas />} />
        <Route path="/visarequestreport" element={<VisaRequestReports />} />
        <Route path="/visasupplierreport" element={<VisaSupplierReports />} />
        <Route
          path="/visarequest/:visaRequestId"
          element={<VisaRequestDetail />}
        />
        <Route path="/visaprices" element={<VisaPrice />} />
        <Route path="/requests" element={<Requests />} />

        <Route path="pendingPayments" element={<PendingPayments />} />
        <Route path="/visarequests" element={<VisaRequests />} />
        <Route path="/visaInvoice/:visaRequestId" element={<VisaInvoice />} />
        <Route path="visaHistory/:visaRequestId" element={<VisaHistory />} />

        <Route path="/credithistory" element={<CreditHistory />} />
         <Route path="/bus/search" element={<BusSearch />} />
          <Route path="/bus/results" element={<BusResults />} />
          <Route path="/bus/seats" element={<BusSeatSelection />} />
          <Route path="/bus/payment" element={<BusPayment />} />
          <Route
            path="/bus/booking-confirmation"
            element={<BusBookingConfirmation />}
          />
          <Route path="/bus/bookinglist" element={<BusBookingList />} />
          <Route path="/bus/booking/:bookingId" element={<BookingDetails />} />
           <Route
            path="/companybankaccounts"
            element={<CompanyBankAccounts />}
          />
          <Route path="/super-admin/company/suppliers" element={<CompanySuppliers />} />
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;
